var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h16v16H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 1.516a8.174 8.174 0 0 0-8 8.337 8.562 8.562 0 0 0 1.085 4.192.872.872 0 0 0 .762.44h12.306a.872.872 0 0 0 .762-.44A8.562 8.562 0 0 0 16 9.853a8.174 8.174 0 0 0-8-8.337zm0 1.853a.885.885 0 0 1 .842.685 1.585 1.585 0 0 0-.1.193l-.256.8a.843.843 0 0 1-.49.174.927.927 0 0 1 0-1.853zm-5.333 8.336a.927.927 0 0 1 0-1.853.927.927 0 0 1 0 1.853zM4 7.074a.927.927 0 1 1 .889-.926.908.908 0 0 1-.889.926zm6.855-2.1-1.7 5.326a1.874 1.874 0 0 1 .38 2.328H6.469a1.892 1.892 0 0 1-.247-.926 1.817 1.817 0 0 1 1.664-1.841l1.7-5.327a.658.658 0 0 1 .843-.439.7.7 0 0 1 .421.879zm.407 1.656.431-1.348a.846.846 0 0 1 .307-.06.927.927 0 0 1 0 1.853.869.869 0 0 1-.738-.441zm2.071 5.072a.927.927 0 1 1 .889-.926.908.908 0 0 1-.889.929z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.09eaaeefb2d988d5a8700bda386a481a.svg";
export { ForwardRef as ReactComponent };